import {IShopRatingSummary} from "@connox/typescript-library";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import Checkbox from "../../lib/form/Checkbox/Checkbox";
import {useMediaQuery} from "react-responsive";
import styles from "./ShopRatingSummary.module.scss";

const ShopRatingSummary: React.FC<{
  summary: IShopRatingSummary;
  filterSet: Set<number>;
  onFilterChange?: (filterSet: Set<number>) => void;
}> = ({summary, filterSet, onFilterChange}) => {
  const {t} = useTranslation();
  const sum = summary["1"] + summary["2"] + summary["3"] + summary["4"] + summary["5"];
  const isMobile = useMediaQuery({maxWidth: 650});
  const isSmallMobile = useMediaQuery({maxWidth: 350});
  const barSize = isMobile ? (isSmallMobile ? 100 : 150) : 220;
  const [filterState, setFilterState] = useState<Set<number>>(filterSet);

  return (
    <div className={styles.summaryWrapper}>
      <div className={styles.ratingSummary}>
        {[5, 4, 3, 2, 1].map((index) => {
          const ratingValue = summary[index] as number;

          return (
            <div key={`star${index}`} className={styles.summaryRow}>
              <Checkbox
                checked={filterState?.has(index) || false}
                onChange={(checked) => {
                  setFilterState((prevState) => {
                    if (checked) {
                      prevState.add(index);
                    } else {
                      prevState.delete(index);
                    }
                    if (onFilterChange) {
                      onFilterChange(prevState);
                    }

                    return prevState;
                  });
                }}
              >
                <span className={styles.starsLabel}>{t("{{star}} Sterne", {star: index})}</span>
              </Checkbox>
              <div
                className={styles.blackBar}
                style={{
                  width: Math.round((ratingValue / sum) * barSize),
                  borderRadius: ratingValue === sum ? "5px" : "5px 0 0 5px",
                }}
              />
              <div
                className={styles.grayBar}
                style={{
                  width: barSize - Math.round((ratingValue / sum) * barSize),
                  borderRadius: !ratingValue ? "5px" : "0 5px 5px 0",
                }}
              />
              <span>({ratingValue})</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default ShopRatingSummary;
